import cn from 'classnames'
import { Button, BUTTON_TYPES } from '../Button'
import { Typography } from '../Typography'
import { ReactComponent as ErrorIcon } from 'assets/svg/ErrorIcon.svg'
import { BannerProps } from './types'
import './banner.error.scss'

export const Error = ({ text, button, className, subtext }: BannerProps) => (
  <div
    className={cn(
      'error-banner row gap-12 space-between align-center',
      className
    )}
  >
    <div className="column gap-8">
      <div className="row gap-12 align-start">
        <ErrorIcon />
        <Typography.Body1 className="error-banner__content-text">
          {text}
        </Typography.Body1>
      </div>
      {!!button?.length && (
        <Button
          type={BUTTON_TYPES.GHOST}
          onClick={button[0].onButtonClick}
          upperCase
        >
          {button[0].buttonText}
        </Button>
      )}

      {subtext && (
        <Typography.Caption className="mt-8 error-banner__subtext">
          {subtext}
        </Typography.Caption>
      )}
    </div>
  </div>
)
